import {createActionGroup, emptyProps} from '@ngrx/store';
import {HTTP_LOADING_FEATURE_KEY} from './http-loading.types';

export const HttpLoadingActions = createActionGroup({
  source: HTTP_LOADING_FEATURE_KEY,
  events: {
    'Request Starting': emptyProps(),
    'Request Complete': emptyProps()
  }
});
